var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".max-min{width:50%;height:1.066667rem;text-align:center;display:inline-block;line-height:1.066667rem}.up-frame{background-image:url(" + escape(require("../../../static/img/biaoge-red.png")) + ")}.down-frame,.up-frame{width:.213333rem;height:.266667rem;margin-right:.133333rem;background-size:cover;background-repeat:no-repeat;display:inline-block}.down-frame{background-image:url(" + escape(require("../../../static/img/biaoge-green.png")) + ")}.report-bottom{margin-bottom:1.066667rem}.report-table-title{height:1.5rem;line-height:1.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-252a20c5","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/myreport/LabDetail.vue
// module id = 422
// module chunks = 0